import React, { Component } from "react";
import withAuthorization from "../../components/Authorization/withAuthorization";
import Stepper from "react-stepper-horizontal";
import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import { Button, Modal } from "react-bootstrap";
import { useState } from "react";
import Header from "../../components/Header/Header";
import Loading from "../../components/Loading/Loading";

//? import login images
import RegisterLogin from "./RegisterLoginGuide";
//? import subscribe plan images
import SubscribePlan from "./SubscribePlanGuide";
//? import register/add lock images
import RegisterLock from "./RegisterLockGuide";
//? import invite members images
import InviteMember from "./InviteMemberGuide";
//? import add recipient images
import AddRecipient from "./AddRecipientGuide";
//? import share lock images
import ShareLock from "./ShareLockGuide";
//? import retract lock iamges
import RetractLock from "./RetractLockGuide";
import FullGuide from "./FullGuide";

import step1image from "../../assets/img/tutorialimages/starterguidestep1.png";
import step2image from "../../assets/img/tutorialimages/starterguidestep2.png";
import step3image from "../../assets/img/tutorialimages/starterguidestep3.png";
import step4image from "../../assets/img/tutorialimages/starterguidestep4.png";
import step5image from "../../assets/img/tutorialimages/starterguidestep5.png";
import step6image from "../../assets/img/tutorialimages/starterguidestep6.png";
import step7image from "../../assets/img/tutorialimages/starterguidestep7.png";

import LocalizedStrings from "react-localization";

import starterguide1image1 from "../../assets/img/dashboardimages/starterguidesteps/starterguide1v2.png";
import starterguide1image2 from "../../assets/img/dashboardimages/starterguidesteps/starterguide2v2.png";
import starterguide1image3 from "../../assets/img/dashboardimages/starterguidesteps/starterguide3v2.png";
import starterguide1image4 from "../../assets/img/dashboardimages/starterguidesteps/starterguide4v2.png";
import starterguide1image5 from "../../assets/img/dashboardimages/starterguidesteps/starterguide5v2.png";
import starterguide1image6 from "../../assets/img/dashboardimages/starterguidesteps/starterguide6v2.png";
import starterguide1image7 from "../../assets/img/dashboardimages/starterguidesteps/starterguide7v2.png";

let localizationStrings = new LocalizedStrings({
  en: {
    step1: "Register and Login",
    step2: "Redeem / Subscribe to a plan",
    step3: "Add a lock",
    step4: "Invite members",
    step5: "Add recipient",
    step6: "Share lock",
    step7: "Retract lock",
    goTo: "GET STARTED",
    skip: "SKIP TUTORIAL",
  },
  ja: {
    step1: "新規登録・ログイン",
    step2: "プラン選択・ご契約",
    step3: "スマートロック登録",
    step4: "メンバー登録",
    step5: "受信者の追加",
    step6: "承認について",
    step7: "アクセス権限解除",
    goTo: "始めましょう",
    skip: "チュートリアルをスキップ",
  },
  es: {
    step1: "Registrarse e Iniciar sesión",
    step2: "Canjear / Suscribirse a un plan",
    step3: "Añadir un candado",
    step4: "Invitar a miembros",
    step5: "Añadir destinatario",
    step6: "Compartir acceso",
    step7: "Retraer acceso",
    goTo: "COMENZAR",
    skip: "OMITIR TUTORIAL",
  },
});

class Tutorial extends Component {
  constructor() {
    super();
    this.state = {
      language: "en", // default language is English

      steps: [
        {
          id: 0,
          completed: true,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step1}
              </div>
              <img
                src={step1image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  border: "5px solid orange",
                  // filter: 'greyscale(100%)'
                }}
              />
            </div>
          ),
          completed: true,
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(1);
          },
        },
        {
          id: 1,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "centre",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step2}
              </div>
              <img
                src={step2image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "100%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  width: "90%",
                  border: "5px solid orange",
                }}
              />
            </div>
          ),
          completed: false,
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(2);
          },
        },
        {
          id: 2,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step3}
              </div>
              <img
                src={step3image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  height: "100%",
                  width: "90%",
                  border: "5px solid orange",
                }}
              />
            </div>
          ),
          completed: false,
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(3);
          },
        },
        {
          id: 3,
          completed: false,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step4}
              </div>
              <img
                src={step4image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  height: "100%",
                  width: "90%",
                  border: "5px solid orange",
                }}
              />
            </div>
          ),
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(4);
          },
        },
        {
          id: 4,
          completed: false,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step5}
              </div>
              <img
                src={step5image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  height: "100%",
                  width: "90%",
                  border: "5px solid orange",
                }}
              />
            </div>
          ),
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(5);
          },
        },
        {
          id: 5,
          completed: false,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step6}
              </div>
              <img
                src={step6image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  height: "100%",
                  width: "90%",
                  border: "5px solid orange",
                }}
              />
            </div>
          ),
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(6);
          },
        },
        {
          id: 6,
          completed: false,
          title: (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "90%",
                  marginLeft: "auto%",
                  marginRight: "auto%",
                  height: "100%",
                  marginBottom: "8%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: "white",
                  backgroundColor: "rgb(80, 150, 255)",
                }}
              >
                {localizationStrings.step7}
              </div>
              <img
                src={step7image}
                style={{
                  borderRadius: "10px 10px 0 0",
                  marginBottom: "20%",
                  width: "100%",
                  marginLeft: "auto",
                  marginRight: "auto",
                  height: "100%",
                  width: "90%",
                  border: "5px solid orange",
                }}
              />
            </div>
          ),
          href: "",
          onClick: (e) => {
            e.preventDefault();
            this.handlePopup(7);
          },
        },
      ],
      showPopup: false,
      currentPopup: 0,

      popupTitle: "",
      popupImage: [],
    };
    this.handleStepDisable = this.handleStepDisable.bind(this);
    this.handleStepCounter = this.handleStepCounter.bind(this);
    this.handleStepImages = this.handleStepImages.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePopup = this.handlePopup.bind(this);
    this.handlePopupButtonRoute = this.handlePopupButtonRoute.bind(this);
    this.handleStepButtonRoute = this.handleStepButtonRoute.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  async componentWillMount() {
    //? check if the user have already subscribe a plan and if the payment still valid or not
    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid + "/payment/isPaymentValid")
      .once("value")
      .then((snapshot) => {
        let stepArray = this.state.steps;
        if (snapshot.exists()) {
          const isPaymentValid = snapshot.val();
          if (isPaymentValid === true) {
            for (const i in stepArray) {
              if (stepArray[i].id === 1) {
                stepArray[i].completed = true;
                this.setState({ steps: stepArray });
              }
            }
          }
        }
      })
      .catch((err) => customLog(err));

    //?check firebase if user have already completed the tutorial
    await fire
      .database()
      .ref("userSettings/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          let snapVal = snapshot.val();

          this.setState({
            isTutorialCompleted: snapVal.isTutorialCompleted,
          });
        }
      });

    //?check if the user have already add a lock
    fire
      .database()
      .ref("userLocks/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let stepArray = this.state.steps;
        if (snapshot.exists()) {
          for (const i in stepArray) {
            if (stepArray[i].id === 2) {
              stepArray[i].completed = true;
              this.setState({ steps: stepArray });
            }
          }
        }
      })
      .catch((err) => customLog(err));

    //? check if the user already invite a member
    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid + "/members")
      .once("value")
      .then((snapshot) => {
        let stepArray = this.state.steps;
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            const membersList = childSnapshot.val();
            //? remove super admin amoung all the members
            if (membersList.memberEmail !== auth.currentUser.email) {
              for (const i in stepArray) {
                if (stepArray[i].id === 3) {
                  stepArray[i].completed = true;
                  this.setState({ steps: stepArray });
                }
              }
            }
          });
        }
      })
      .catch((err) => customLog(err));

    //? check if the user already have recipient
    fire
      .database()
      .ref("userFriendListIndustrial/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let stepArray = this.state.steps;
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            const recipientList = childSnapshot.val();
            for (const i in stepArray) {
              if (stepArray[i].id === 4) {
                stepArray[i].completed = true;
                this.setState({ steps: stepArray });
              }
            }
          });
        }
      })
      .catch((err) => customLog(err));

    //? check if the user have already add a lock
    fire
      .database()
      .ref("retractableSharingRegistry/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let stepArray = this.state.steps;
        if (snapshot.exists()) {
          for (const i in stepArray) {
            if (stepArray[i].id === 5) {
              stepArray[i].completed = true;
              this.setState({ steps: stepArray });
            }
          }
        }
        customLog(stepArray);
      })
      .catch((err) => customLog(err));

    //? check if the user have already retract a lock
    fire
      .database()
      .ref("retractableSharingRegistry/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        let stepArray = this.state.steps;
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            const childSnapVal = childSnapshot.val();
            let retractArray = childSnapVal.allowAccess;
            if (retractArray === false) {
              for (const i in stepArray) {
                if (stepArray[i].id === 6) {
                  stepArray[i].completed = true;
                  this.setState({ steps: stepArray });
                }
              }
            }
          });
        }
        customLog(stepArray);
      })
      .catch((err) => customLog(err));

    //! FOR LANGUAGE SETTINGS
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid) // get uid from auth person object
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            currentLanguage: snapshot.val(),
          });
        });
    }

    if (this.state.isTutorialCompleted === true) {
      let stepArray = this.state.steps;
      for (let i = 0; i < stepArray.length; i++) {
        if (stepArray[i].completed === false) {
          stepArray[i].completed = true;
          this.setState({ steps: stepArray });
        }
      }
      // console.log(`tutorial completed skip steps`);

      let disableStepArray = this.handleStepDisable();
      // console.log(`current disabel steps `+disableStepArray.length);
      return;
    }
  }

  handleLanguageChange = (lang) => {
    this.setState({ language: lang });
    localizationStrings.setLanguage(lang);
  };

  handleStepCounter() {
    //? do a count on how many true and false is there
    let stepArray = this.state.steps;
    let counter = 0;
    for (let i = 0; i < stepArray.length; i++) {
      if (stepArray[i].completed === true) {
        counter++;
      }
    }
    return counter;
  }

  handleStepDisable() {
    //? do a count on how many people steps are disabled
    let disableStepArray = [];
    let stepArray = this.state.steps;
    for (let i = 0; i < stepArray.length; i++) {
      if (stepArray[i].completed === false) {
        disableStepArray.push(stepArray[i].id);
      }
    }
    return disableStepArray;
  }

  handleStepImages() {
    //? check the lowest id of the disable steps
    let disableStepArray = this.handleStepDisable();
    var smallest = disableStepArray.sort((a, b) => a - b);
    const minDisableStepArray = smallest[0];
    // customLog(minDisableStepArray);
    //? if smallest value === 0 (steps 1) display login guide
    if (minDisableStepArray === 0) {
      return <RegisterLogin />;
    } //? if smallest value === 1 (steps 2) display subscribe plan guide
    else if (minDisableStepArray === 1) {
      return <SubscribePlan />;
    } //? if smallest value === 2 (steps 3) display register/add a lock guide
    else if (minDisableStepArray === 2) {
      return <RegisterLock />;
    } //? if smallest value === 3 (steps 4) display invite members guide
    else if (minDisableStepArray === 3) {
      return <InviteMember />;
    } //? if smallest value === 4 (steps 5) display add recipient guide
    else if (minDisableStepArray === 4) {
      return <AddRecipient />;
    } //? if smallest value === 6 (steps 6) display sharing lock guide
    else if (minDisableStepArray === 5) {
      return <ShareLock />;
    } //? if smallest value === 6 (steps 7) display retract lock guide
    else if (minDisableStepArray === 6) {
      return <RetractLock />;
    } else {
      if (!this.state.isTutorialCompleted) {
        fire
          .database()
          .ref("userSettings/" + auth.currentUser.uid)
          .update({
            isTutorialCompleted: true,
          });
        return alert("You have Completed the Starter Guide"), (<FullGuide />);
      } else {
        return <FullGuide />;
      }
    }
  }

  handlePopup(step) {
    this.setState({
      showPopup: true,
      currentPopup: step,
    });
    if (step === 1) {
      this.setState({
        popupTitle: localizationStrings.step1,
        popupImage: [<RegisterLogin />],
      });
    } else if (step === 2) {
      this.setState({
        popupTitle: localizationStrings.step2,
        popupImage: [<SubscribePlan />],
      });
    } else if (step === 3) {
      this.setState({
        popupTitle: localizationStrings.step3,
        popupImage: [<RegisterLock />],
      });
    } else if (step === 4) {
      this.setState({
        popupTitle: localizationStrings.step4,
        popupImage: [<InviteMember />],
      });
    } else if (step === 5) {
      this.setState({
        popupTitle: localizationStrings.step5,
        popupImage: [<AddRecipient />],
      });
    } else if (step === 6) {
      this.setState({
        popupTitle: localizationStrings.step6,
        popupImage: [<ShareLock />],
      });
    } else if (step === 7) {
      this.setState({
        popupTitle: localizationStrings.step7,
        popupImage: [<RetractLock />],
      });
    }
  }

  handleClose() {
    this.setState({ showPopup: false });
  }

  handlePopupButtonRoute() {
    const currentPopup = this.state.currentPopup;
    let navigateTo = "";
    if (currentPopup === 2) {
      navigateTo = "/plans";
    } else if (currentPopup === 3) {
      navigateTo = "/locklist";
    } else if (currentPopup === 4) {
      navigateTo = "/accountManagement";
    } else if (currentPopup === 5) {
      navigateTo = "/userManagement";
    } else if (currentPopup === 6) {
      navigateTo = "/grantAccess";
    } else if (currentPopup === 7) {
      navigateTo = "/retractableAccess";
    }
    return navigateTo;
  }

  handleStepButtonRoute() {
    const currentStep = this.handleStepCounter();
    let navigateTo = "";
    if (currentStep === 1) {
      navigateTo = "/plans";
    } else if (currentStep === 2) {
      navigateTo = "/locklist";
    } else if (currentStep === 3) {
      navigateTo = "/accountManagement";
    } else if (currentStep === 4) {
      navigateTo = "/userManagement";
    } else if (currentStep === 5) {
      navigateTo = "/grantAccess";
    } else if (currentStep === 6) {
      navigateTo = "/retractableAccess";
    }
    return navigateTo;
  }

  handleSkipTutorial() {
    fire
      .database()
      .ref("userSettings/" + auth.currentUser.uid)
      .update({
        isTutorialCompleted: true,
      });
    window.location.reload(true);
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.currentLanguage === "en") {
      localizationStrings.setLanguage("en");
    } else if (this.state.currentLanguage === "ja") {
      localizationStrings.setLanguage("ja");
    } else if (this.state.currentLanguage === "es") {
      localizationStrings.setLanguage("es");
    }

    const { steps } = this.state;
    steps[0].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {localizationStrings.step1}
        </div>
        <img
          className="stepImage"
          src={step1image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );
    steps[1].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "95%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "centre",
          }}
        >
          {localizationStrings.step2}
        </div>
        <img
          className="stepImage"
          src={step2image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "100%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            width: "90%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );
    steps[2].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {localizationStrings.step3}
        </div>
        <img
          className="stepImage"
          src={step3image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
            width: "90%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );
    steps[3].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {localizationStrings.step4}
        </div>
        <img
          className="stepImage"
          src={step4image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
            width: "90%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );

    steps[4].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {localizationStrings.step5}
        </div>
        <img
          className="stepImage"
          src={step5image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
            width: "90%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );
    steps[5].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {localizationStrings.step6}
        </div>
        <img
          className="stepImage"
          src={step6image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
            width: "90%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );

    steps[6].title = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          height: "180px",
        }}
      >
        <div
          style={{
            width: "90%",
            marginLeft: "auto%",
            marginRight: "auto%",
            height: "100%",
            borderRadius: "10px",
            textAlign: "center",
          }}
        >
          {localizationStrings.step7}
        </div>
        <img
          className="stepImage"
          src={step7image}
          style={{
            borderRadius: "10px",
            marginBottom: "16.5%",
            marginTop: "5%",
            width: "100%",
            marginLeft: "auto",
            marginRight: "auto",
            height: "100%",
            width: "90%",
            border: "5px solid orange",
            boxShadow: "1px 8px 10px rgba(0, 0, 0, 0.3)",
          }}
        />
      </div>
    );

    return (
      <div>
        <style>
          {`
            .stepImage {
              transition: transform 0.3s, box-shadow 0.3s;
            }

            .stepImage:hover {
              transform: translateY(-10px) scale(1.08);
              box-shadow: 1px 12px 10px rgba(0, 0, 0, 0.25) !important;
            }
          `}
        </style>
        <Stepper
          steps={steps}
          activeStep={this.handleStepCounter()}
          disabledSteps={this.handleStepDisable()}
          defaultColor="lightgrey"
          defaultTitleOpacity="0.5"
        />
        <Modal
          show={this.state.showPopup}
          onHide={this.handleClose}
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                {this.state.popupTitle}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <button
              className="gotoBtn"
              style={{
                display: this.state.isTutorialCompleted ? "none" : "block",
              }}
              onClick={() => {
                window.location.href = this.handlePopupButtonRoute();
              }}
            >
              {localizationStrings.goTo}
            </button>
            {this.state.popupImage}
          </Modal.Body>
        </Modal>

        <div
          style={{
            border: "1px solid grey",
            borderRadius: "5px",
            backgroundColor: "white",
          }}
        >
          <button
            style={{
              borderRadius: "50px",
              border: "none",
              padding: "8px",
              margin: "10px",
              fontSize: "14px",
              width: "18%",
              backgroundColor: "orange",
              color: "black",
              float: "left",
              display: this.state.isTutorialCompleted ? "none" : "block",
            }}
            onClick={() => {
              this.handleSkipTutorial();
            }}
          >
            {localizationStrings.skip}
          </button>
          <button
            style={{
              borderRadius: "50px",
              border: "none",
              padding: "8px",
              margin: "10px",
              fontSize: "14px",
              width: "18%",
              backgroundColor: "orange",
              color: "black",
              float: "right",
              display: this.state.isTutorialCompleted ? "none" : "block",
            }}
            onClick={() => {
              window.location.href = this.handleStepButtonRoute();
            }}
          >
            {localizationStrings.goTo}
          </button>
          {this.handleStepImages()}
        </div>
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(Tutorial);
